import { Observable } from "rxjs";
import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { SessionService } from "@common/services/session.service";

export default function httpSessionInterceptor(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
    const sessionService = inject(SessionService);
    
    if(sessionService.value){
        const headers = req.headers
        .set('Accept', '*/*')
        // .set('Content-Type', 'application/json')
        .set('Authorization', `Bearer ${sessionService.value}`);

        req = req.clone({
            headers
        })
    }

    return next(req);
}

